import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
const controller = rpcController("MatrizTiempo");
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";

type Entity = models.MatrizTiempos;
type EntityDto = models.MatrizTiemposDTO;
export const MatrizTiempos = cacheResource({
    /**Obtiene una entidad */
    get: async (id: number): Promise<EntityDto> => await controller('Get', { id }),

    /**Obtiene todas las entidades filtradas por la zona */
    query: async (): Promise<EntityDto[]> => await controller('Query', {}),

    /**Agrega una entidad */
    add: async (entity: Entity): Promise<number> => await controller('Add', {}, entity),

    /**Actualiza la entidad */
    update: async (entity: Entity): Promise<void> => await controller('Update', {}, entity),

    /**Borra un elemento de la matriz */
    delete: async (id: number): Promise<void> => await controller('Delete', { id }),

    /**
     * Obtiene los pares de sucursales que faltan
     */
    ParesFaltantes: async (): Promise<models.ParSucursalMatrizTiempos[]> => await controller('ParesFaltantes', {}),

}, {
        query: true,
        get: true,
        ParesFaltantes: true
    }, {
        add: true,
        update: true,
        delete: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/matriztiempos.tsx